import { Box, Typography } from "@mui/material";

function OpcaoServicoSuspensa() {
  return (
    <Box width='100%' borderRadius="8px" bgcolor='#61616121' px={3} py={2} borderLeft={"10px solid #8BE68A"}>
      <Typography variant='body2' color='textSecondary' align="left">
        Atenção: estamos temporariamente com a proposta "Gerador com instalação" suspensa.
      </Typography>
    </Box>
  );
}

export { OpcaoServicoSuspensa }